module.exports = __webpack_public_path__ + "img/ms-team-2023-24-2.12a01d6.jpg";